<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：营业数据
      -->
  <div class="user">

    
    <div style="width:100%;">

      <div class="bg-white rounded-lg shadow-sm p-6 mb-6">
        <div class="flex justify-between items-center">
          <div class="flex items-center gap-4">
            <!-- 供应商下拉选择 -->
            <div class="relative"  v-if="isuse == 1">
              <button @click="toggleSupplierDropdown" class="flex items-center gap-2 px-4 py-2 border border-gray-200 rounded-button bg-white text-gray-700 hover:bg-gray-50">
                <i class="fas fa-building"></i>
                <span class="whitespace-nowrap">{{ selectedSupplier.name || '选择供应商' }}</span>
                <i class="fas fa-chevron-down text-gray-400"></i>
              </button>
              <div v-if="showSupplierDropdown" class="absolute z-10 w-56 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg">
                <div class="py-2">
                  <div v-for="(item,index) in supply"  :key="index" @click="selectSupplier(item)" class="px-4 py-2 hover:bg-gray-50 cursor-pointer">
                     {{item.name}}
                  </div>
                </div>
              </div>
            </div>
            

          </div>


      
        </div>
      </div>
     
      <!--搜索表单-->
      <div class="common-seach-wrap">
        <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
          
        <el-form-item label="订单号">
          <el-input size="small" v-model="formInline.order_no" placeholder="请输入订单号"></el-input></el-form-item>
          
        <el-form-item label="产品名称"><el-input size="small" v-model="formInline.product_name" placeholder="请输入产品名称"></el-input></el-form-item>
          
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          </el-form-item>

          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="onExport">导出</el-button>
               
            </el-form-item>
        </el-form>
      </div>
  
      <!--内容-->
      <div class="product-content">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%"
       :row-key="row => row.product_id || row.order_no"
  highlight-current-row

          v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column  prop="order_no" label="订单号"  ></el-table-column>

          <el-table-column prop="warehouse_kw_text" label="库位"  ></el-table-column>
            <el-table-column  prop="product_name" label="产品名称"  ></el-table-column>
            <el-table-column  prop="product_attr" label="规格" ></el-table-column>

      
             <!-- 销售额 -->
             <el-table-column label="进货单价" prop="price" width="60"></el-table-column>
             
             <el-table-column label="销售单价" prop="xs_price" ></el-table-column>
             <el-table-column  prop="total_quantity" label="数量"  width="60"></el-table-column>
        
              <!-- 销售成本列 -->
            <el-table-column label="销售成本" prop="total_cost" > </el-table-column>

              <!-- 销售额 -->
            <el-table-column label="销售额" prop="amount" ></el-table-column>

               <!-- 销售额 -->
               <el-table-column label="销售总额" prop="total_amount" ></el-table-column>


           
            <!-- 运费 -->
            <el-table-column label="运费" prop="express_price" width="60"> </el-table-column>

            <!-- 配送费 -->
            <el-table-column label="配送费" prop="delivery_amount" > </el-table-column>

               <!-- 配送费 -->
               <el-table-column label="首单免配送费金额/元" prop="first_order_delivery_price_free" > </el-table-column>


                  <!-- 配送费 -->
            <el-table-column label="非首单免配送费金额/元" prop="other_order_delivery_price_free" > </el-table-column>



            <!-- 毛利列 -->
            <el-table-column label="毛利" prop="gross_profit" > 
              
              <template slot-scope="scope">

                {{ calculateGross(scope.row) }}元

              </template>
            </el-table-column>

            <!-- 毛利率列 -->
            <el-table-column label="毛利率" prop="gross_margin" >
              <template slot-scope="scope">{{ calculateGrossMargin(scope.row) }}%</template>
            </el-table-column>

    
          </el-table>
        </div>
  
        <!--分页-->
        <div class="pagination">
          <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background :current-page="curPage"
          :page-sizes="[10,20, 100,500, 1000]"
          layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumber"></el-pagination>
        </div>
      </div>
    </div>

 
  </div>
</template>

<script>
  import Warehouse_managementApi from '@/api/warehouse_management.js';

  import ReportApi from '@/api/report.js';
  import Supply_s from '@/components/select/warehouse';
  import qs from 'qs'
export default {
  components: {
    Supply_s
  },
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
         create_time: [],
         warehouse_kw_id:0,
         product_name:"",
         warehouse_id:0,
         warehouse_kw_id:0,
         order_no:"",
         startDate: '',
         endDate: '',
      },
      warehouse:[],

      selectedSupplier: {'name':""},
        showSupplierDropdown: false,
        startDate: '',
        endDate: '',
        supply:[],
 
        isuse:0,
     
    };
  },
  created() {
    var self = this;
      self.getInas({},function(res){
        self.isuse = res
      })
    this.getSupplys();
    this.getTableList()
  },

  methods: {
    onExport: function() {
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/report/exportSalestable?' + qs.stringify(this.formInline);
      },

      getSupplys(){
            let self = this;
    
    
            Warehouse_managementApi.getSupply({}, true)
                .then(data => {
              
                self.supply = data.data.supply
           
                })
                .catch(error => {
                });
        },
        toggleSupplierDropdown() {
        this.showSupplierDropdown = !this.showSupplierDropdown;
      },
      selectSupplier(supplier) {
        this.selectedSupplier = supplier;
        this.showSupplierDropdown = false;
        this.formInline.supply_id = supplier.supply_id
      },
      handleDateChange() {
        if (this.startDate && this.endDate) {
          this.refreshData();
        }
      },
      toggleWholesaleDropdown() {
        this.showWholesaleDropdown = !this.showWholesaleDropdown;
        this.showTimeDropdown = false;
        this.showStoreDropdown = false;
      },
      toggleStoreDropdown() {
        if (this.selectedWholesale) {
          this.showStoreDropdown = !this.showStoreDropdown;
          this.showWholesaleDropdown = false;
        }
      },
    formatCurrency(value) {
      return value; // 格式化为货币格式
    },
    calculateGross(row){
      // 计算毛利
      var total_amount = row.total_amount?parseFloat(row.total_amount):0;
      var total_cost = row.total_cost?parseFloat(row.total_cost):0;
      var express_price = row.express_price?parseFloat(row.express_price):0;
      var delivery_amount = row.delivery_amount?parseFloat(row.delivery_amount):0;
      var first_order_delivery_price_free = row.first_order_delivery_price_free?parseFloat(row.first_order_delivery_price_free):0;
      var other_order_delivery_price_free = row.other_order_delivery_price_free?parseFloat(row.other_order_delivery_price_free):0;

      const grossProfit = total_amount -total_cost + express_price - delivery_amount -first_order_delivery_price_free - other_order_delivery_price_free;
      

      if(row.total_amount){
        return this.getPrice(grossProfit);
      }else{
        return 0; // 返回毛利率并保留两位小数
      }


    },
    calculateGrossMargin(row) {
       // 计算毛利
       var total_amount = row.total_amount?parseFloat(row.total_amount):0;
      var total_cost = row.total_cost?parseFloat(row.total_cost):0;
      var express_price = row.express_price?parseFloat(row.express_price):0;
      var delivery_amount = row.delivery_amount?parseFloat(row.delivery_amount):0;
      var first_order_delivery_price_free = row.first_order_delivery_price_free?parseFloat(row.first_order_delivery_price_free):0;
      var other_order_delivery_price_free = row.other_order_delivery_price_free?parseFloat(row.other_order_delivery_price_free):0;

      const grossProfit = total_amount -total_cost + express_price - delivery_amount -first_order_delivery_price_free - other_order_delivery_price_free;
     
      // 计算毛利率
      const grossMargin = (grossProfit / row.total_amount) * 100;
      if(row.total_amount){
        return this.getPrice(grossMargin); // 返回毛利率并保留两位小数
      }else{
        return 0; // 返回毛利率并保留两位小数
      }
     
    },
    roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        return this.roundToDecimalPlace(price,2)
      },
    handleCurrentChangeS(val){
      this.formInline.warehouse_id = val.warehouse_id
      this.formInline.warehouse_kw_id = val.warehouse_kw_id
      this.getTableList();
    },
    reasts(){

      this.formInline.warehouse_id = 0
      this.formInline.warehouse_kw_id = 0
      this.getTableList();
    },
     /*搜索查询*/
     onSubmit() {
      let self = this
      self.curPage = 1
      this.getTableList()
    },
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },
     /*选择第几页*/
     handleCurrentChange(val) {
      this.curPage = val
      this.getTableList()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },
    getTableList(){
      let self = this;
      let params = self.formInline;
    params.page = self.curPage;
    params.list_rows = self.pageSize;
    ReportApi.salestable(params)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber =  data.data.list.total
        })
        .catch((error) => {});
    }

  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/report/salestable.vue